import { Close, Edit, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Card, CardActions, CardContent, CardHeader, FormControl, Grid, InputAdornment, MenuItem, Select } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonButton from 'components/ArgonButton'
import ArgonInput from 'components/ArgonInput'
import ArgonTypography from 'components/ArgonTypography'
import { CustomDescrypt } from 'global/func'
import { getDataWithResponse } from 'global/getFunc'
import { postSubmit } from 'global/postFunc'
import React, { useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt'
import userStore from 'store/userStore'

const UpdateKomponen = ({ idKomponen, dataKomponen, updating, setUpdating, enableEdit = true }) => {
    const { user, addReq } = userStore(state => ({ user: state.user, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)

    const [saving, setSaving] = useState(false)

    const [editKomponen, setEditKomponen] = useState(false)

    const [pdn, setPdn] = useState('')
    const [tkdn, setTkdn] = useState('')
    const [metodePengadaan, setMetodePengadaan] = useState('')
    const [pemilihanPenyedia, setPemilihanPenyedia] = useState('')
    const [noKontrak, setNoKontrak] = useState('')
    const [tglKontrak, setTglKontrak] = useState('')
    const [tglMulai, setTglMulai] = useState('')
    const [tglSelesai, setTglSelesai] = useState('')
    const [tglST, setTglST] = useState('')
    const [waktuPelaksanaan, setWaktuPelaksanaan] = useState('')
    const [namaPenyedia, setNamaPenyedia] = useState('')
    const [nilaiKontrak, setNilaiKontrak] = useState('')
    const [penerimaManfaat, setPenerimaManfaat] = useState('')
    const [projStrategis, setProjStrategis] = useState('')
    // const [prioritas, setPrioritas] = useState('')

    const [listKec, setListKec] = useState([])
    const [kec, setKec] = useState('')
    const [listDesa, setListDesa] = useState([])
    const [desa, setDesa] = useState('')

    const [geometryType, setGeometryType] = useState('')
    const [latitude, setLatitude] = useState('')
    const [longitude, setLongitude] = useState('')
    const [path, setPath] = useState('')

    const [arrRek, setArrRek] = useState([])

    useEffect(() => {
        console.log(dataKomponen);
        setPdn(dataKomponen.pdn)
        setTkdn(dataKomponen.tkdn)
        setMetodePengadaan(dataKomponen.metode_pengadaan)
        setPemilihanPenyedia(dataKomponen.pemilihan_penyedia)
        setNoKontrak(dataKomponen.no_kontrak)
        setTglKontrak(dataKomponen.tgl_kontrak)
        setTglMulai(dataKomponen.tgl_mulai)
        setTglSelesai(dataKomponen.tgl_selesai)
        setTglST(dataKomponen.tgl_serah_terima)
        setWaktuPelaksanaan(dataKomponen.waktu_pelaksanaan)
        setNamaPenyedia(dataKomponen.nama_penyedia)
        setNilaiKontrak(dataKomponen.nilai_kontrak)
        setKec(dataKomponen.kec)
        setDesa(dataKomponen.desa)
        setPenerimaManfaat(dataKomponen.penerima_manfaat)
        setLatitude(dataKomponen.latitude)
        setLongitude(dataKomponen.longitude)
        setPath(dataKomponen.path)
        setProjStrategis(dataKomponen.projek_strategis)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataKomponen])

    useEffect(() => {
        console.log(dataKomponen);
        if (dataKomponen.kode_rekening_akun !== undefined) {
            let txt = dataKomponen.kode_rekening_akun;
            let arr = txt.split('.');
            setArrRek(arr)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataKomponen])

    useEffect(() => {
        setGeometryType((arrRek[0] === '5' && arrRek[1] === '2' && arrRek[2] === '04' && (arrRek[3] === '01' || arrRek[3] === '04' || arrRek[3] === '99')) ? 'polyline' : 'point')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrRek])

    const updateKomponen = (e) => {
        addReq()
        e.preventDefault();
        setSaving(true)
        postSubmit(
            `/admin-opd/komponen-belanja/update/${idKomponen}`,
            {
                _method: 'PUT',
                pdn: pdn,
                tkdn: tkdn,
                metode_pengadaan: metodePengadaan,
                pemilihan_penyedia: pemilihanPenyedia,
                no_kontrak: noKontrak,
                tgl_kontrak: tglKontrak,
                tgl_mulai: tglMulai,
                tgl_selesai: tglSelesai,
                tgl_serah_terima: tglST,
                waktu_pelaksanaan: waktuPelaksanaan,
                nama_penyedia: namaPenyedia,
                nilai_kontrak: nilaiKontrak,
                projek_strategis: projStrategis,
                kec: kec,
                desa: desa,
                penerima_manfaat: penerimaManfaat,
                geometry_type: geometryType,
                latitude: latitude,
                longitude: longitude,
                path: path,
                lokasi: decodedUser.nm_pd,
            },
            decryptedUser,
            (res) => {
                setUpdating(!updating)
                setSaving(false)
                setEditKomponen(false)
            },
            (res) => {
                setSaving(false)
            }
        )
    }

    useEffect(() => {
        (metodePengadaan === 'Swakelola' || metodePengadaan === 'Penyedia dalam Swakelola') && setPenerimaManfaat('On Site')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [metodePengadaan])

    useEffect(() => {
        penerimaManfaat === 'Off Site' && reqKec()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [penerimaManfaat])

    useEffect(() => {
        if (kec !== '') {
            if (kec === '999') {
                setDesa('9999')
            }
            else {
                // setDesa('')
                reqDesa(kec)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [kec])

    const reqKec = () => {
        addReq()
        getDataWithResponse(
            `/kecamatan`,
            decryptedUser,
            (res) => {
                setListKec(res)
            },
            (res) => {
                console.log(res)
            }
        )
    }

    const reqDesa = (params) => {
        addReq()
        getDataWithResponse(
            `/desa/by-kec/${params}`,
            decryptedUser,
            (res) => {
                setListDesa(res)
            },
            (res) => {
                console.log(res)
            }
        )
    }

    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const handleNilaiKontrakChange = (event) => {
        setNilaiKontrak(addCommas(removeNonNumeric(event.target.value)))
    }

    return (
        <Card component='form' onSubmit={updateKomponen}>
            <CardHeader
                title={
                    <ArgonTypography variant='subtitle2' fontWeight="bold">Lengkapi Data</ArgonTypography>
                }
                action={
                    enableEdit &&
                    <ArgonButton
                        variant='contained'
                        color="primary"
                        size="small"
                        startIcon={<Edit />}
                        onClick={() => {
                            setEditKomponen(true)
                        }}
                    >
                        Edit
                    </ArgonButton>
                }
            />
            <CardContent>
                <ArgonBox mb={1}>
                    <Grid container spacing={2} justifyContent='center'>
                        {
                            (arrRek[0] === '5' && arrRek[1] === '2') && (
                                <>
                                    <Grid item lg={3} md={6} xs={12}>
                                        <ArgonBox mb={1} ml={0.5}>
                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                PDN
                                            </ArgonTypography>
                                        </ArgonBox>
                                        <FormControl fullWidth>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                // defaultValue={pdn}
                                                value={pdn || ''}
                                                onChange={(e) => {
                                                    setPdn(e.target.value)
                                                }}
                                                required
                                                disabled={!editKomponen}
                                            >
                                                <MenuItem key={0} value='Ya'>Ya</MenuItem>
                                                <MenuItem key={1} value='Tidak'>Tidak</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item lg={3} md={6} xs={12}>
                                        <ArgonBox mb={1} ml={0.5}>
                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                TKDN
                                            </ArgonTypography>
                                        </ArgonBox>
                                        <ArgonInput
                                            type="text"
                                            required
                                            size="medium"
                                            value={tkdn || ''}
                                            onChange={(e) => { setTkdn(e.target.value) }}
                                            autoComplete='off'
                                            endAdornment={
                                                <InputAdornment position="end" fontSize='small'>
                                                    <ArgonTypography fontSize='small'>%</ArgonTypography>
                                                </InputAdornment>
                                            }
                                            disabled={!editKomponen}
                                        />
                                    </Grid>
                                </>
                            )
                        }
                        {/* <Grid item lg={3} md={6} xs={12}>
                            <ArgonBox mb={1} ml={0.5}>
                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                    Mekanisme Pelaksanaan
                                </ArgonTypography>
                            </ArgonBox>
                            <FormControl fullWidth>
                                <Select
                                    value={metodePengadaan || ''}
                                    onChange={(e) => {
                                        setMetodePengadaan(e.target.value)
                                        setPemilihanPenyedia('')
                                    }}
                                    required
                                    disabled={!editKomponen}
                                >
                                    <MenuItem key={1} value='Penyedia'>Penyedia</MenuItem>
                                    <MenuItem key={2} value='Swakelola'>Swakelola</MenuItem>
                                    <MenuItem key={3} value='Penyedia dalam Swakelola'>Penyedia dalam Swakelola</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid> */}
                        {
                            metodePengadaan === 'Penyedia' &&
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Pemilihan Penyedia
                                    </ArgonTypography>
                                </ArgonBox>
                                <FormControl fullWidth>
                                    {/* <InputLabel id="demo-simple-select-label">Pilih OPD</InputLabel> */}
                                    <Select
                                        value={pemilihanPenyedia || ''}
                                        onChange={(e) => {
                                            setPemilihanPenyedia(e.target.value)
                                        }}
                                        required={metodePengadaan === 'Penyedia'}
                                        disabled={!editKomponen || metodePengadaan !== 'Penyedia'}
                                    >
                                        <MenuItem key={1} value='e-Purchasing'>e-Purchasing</MenuItem>
                                        <MenuItem key={2} value='Pengadaan Langsung'>Pengadaan Langsung</MenuItem>
                                        <MenuItem key={3} value='Penunjukan Langsung'>Penunjukan Langsung</MenuItem>
                                        <MenuItem key={4} value='Seleksi'>Seleksi</MenuItem>
                                        <MenuItem key={5} value='Tender Cepat'>Tender Cepat</MenuItem>
                                        <MenuItem key={6} value='Tender'>Tender</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        }
                    </Grid>
                </ArgonBox>
                {
                    metodePengadaan === 'Penyedia' &&
                    <ArgonBox mb={1}>
                        <ArgonBox ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Kontrak
                            </ArgonTypography>
                        </ArgonBox>
                        <Grid container spacing={2} justifyContent='center'>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        No. Kontrak / SPK
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="text"
                                    size="medium"
                                    value={noKontrak || ''}
                                    onChange={(e) => { setNoKontrak(e.target.value) }}
                                    autoComplete='off'
                                    disabled={!editKomponen}
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Tanggal Kontrak
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="date"
                                    placeholder="Date"
                                    size="medium"
                                    value={tglKontrak || ''}
                                    onChange={(e) => { setTglKontrak(e.target.value) }}
                                    autoComplete='off'
                                    disabled={!editKomponen}
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Nama Penyedia
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="text"
                                    size="medium"
                                    value={namaPenyedia || ''}
                                    onChange={(e) => { setNamaPenyedia(e.target.value) }}
                                    autoComplete='off'
                                    disabled={!editKomponen}
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Nilai Kontrak
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="text"
                                    size="medium"
                                    value={nilaiKontrak || ''}
                                    onChange={handleNilaiKontrakChange}
                                    autoComplete='off'
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <ArgonTypography component="label" variant="caption" >
                                                Rp
                                            </ArgonTypography>
                                        </InputAdornment>
                                    }
                                    disabled={!editKomponen}
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Waktu Pelaksanaan
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="text"
                                    size="medium"
                                    value={waktuPelaksanaan || ''}
                                    onChange={(e) => { setWaktuPelaksanaan(e.target.value) }}
                                    autoComplete='off'
                                    disabled={!editKomponen}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <ArgonTypography component="label" variant="caption" >
                                                Hari
                                            </ArgonTypography>
                                        </InputAdornment>
                                    }
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Tanggal Mulai
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="date"
                                    placeholder="Date"
                                    size="medium"
                                    value={tglMulai || ''}
                                    onChange={(e) => { setTglMulai(e.target.value) }}
                                    autoComplete='off'
                                    disabled={!editKomponen}
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Tanggal Selesai
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="date"
                                    placeholder="Date"
                                    size="medium"
                                    value={tglSelesai || ''}
                                    onChange={(e) => { setTglSelesai(e.target.value) }}
                                    autoComplete='off'
                                    disabled={!editKomponen}
                                />
                            </Grid>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Tanggal Serah Terima
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type="date"
                                    placeholder="Date"
                                    size="medium"
                                    value={tglST || ''}
                                    onChange={(e) => { setTglST(e.target.value) }}
                                    autoComplete='off'
                                    disabled={!editKomponen}
                                />
                            </Grid>
                        </Grid>
                    </ArgonBox>
                }
                {
                    metodePengadaan !== '' &&
                    <ArgonBox mb={1}>
                        <ArgonBox ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Lokasi Pekerjaan
                            </ArgonTypography>
                        </ArgonBox>
                        <Grid container spacing={2} justifyContent='center'>
                            <Grid item lg={3} md={6} xs={12}>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Penerima Manfaat
                                    </ArgonTypography>
                                </ArgonBox>
                                <FormControl fullWidth>
                                    <Select
                                        value={penerimaManfaat || ''}
                                        onChange={(e) => {
                                            setPenerimaManfaat(e.target.value)
                                        }}
                                        required
                                        disabled={(!editKomponen || metodePengadaan === 'Swakelola' || metodePengadaan === 'Penyedia dalam Swakelola')}
                                    >
                                        <MenuItem key={0} value='On Site'>On Site</MenuItem>
                                        <MenuItem key={1} value='Off Site'>Off Site</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {
                                penerimaManfaat === 'On Site' &&
                                (
                                    <Grid item lg={9} md={12} xs={12}>
                                        <ArgonBox mb={1} ml={0.5}>
                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                Lokasi
                                            </ArgonTypography>
                                        </ArgonBox>
                                        <ArgonInput
                                            required
                                            size="medium"
                                            value={dataKomponen.lokasi}
                                            // onChange={(e) => { setKoordinat(e.target.value) }}
                                            autoComplete='off'
                                            disabled
                                        />
                                    </Grid>
                                )
                            }
                            {
                                penerimaManfaat === 'Off Site' &&
                                (
                                    <>
                                        <Grid item lg={3} md={6} xs={12}>
                                            <ArgonBox mb={1} ml={0.5}>
                                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                    Kecamatan
                                                </ArgonTypography>
                                            </ArgonBox>
                                            <FormControl fullWidth>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={kec}
                                                    onChange={(e) => {
                                                        // selectKecChange(e)
                                                        setKec(e.target.value)
                                                    }}
                                                    required
                                                    disabled={(!editKomponen || penerimaManfaat === 'On Site')}
                                                >
                                                    <MenuItem key={0} value='999'>Semua / Beberapa Kecamatan</MenuItem>
                                                    {
                                                        listKec.map((kc, index) => (
                                                            <MenuItem key={index + 1} value={kc.id_kec}>{kc.nama_kec}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={12}>
                                            <ArgonBox mb={1} ml={0.5}>
                                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                    Desa / Kelurahan
                                                </ArgonTypography>
                                            </ArgonBox>
                                            <FormControl fullWidth>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={desa}
                                                    onChange={(e) => {
                                                        // selectDesaChange(e)
                                                        setDesa(e.target.value)
                                                    }}
                                                    required
                                                    disabled={(!editKomponen || penerimaManfaat === 'On Site')}
                                                >
                                                    <MenuItem key={0} value='9999'>Semua / Beberapa Desa</MenuItem>
                                                    {
                                                        listDesa.map((ds, index) => (
                                                            <MenuItem key={index + 1} value={ds.id_desa}>{ds.nama_desa}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        {
                                            desa !== '9999' &&
                                                desa !== '' &&

                                                geometryType === 'polyline' ?

                                                <Grid item lg={12} md={6} xs={12}>
                                                    <ArgonBox mb={1} ml={0.5}>
                                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                            Koordinat (x,y)
                                                        </ArgonTypography>
                                                    </ArgonBox>
                                                    <ArgonInput
                                                        required={kec.id_kec !== '999'}
                                                        multiline
                                                        rows={7}
                                                        size="medium"
                                                        value={path}
                                                        onChange={(e) => { setPath(e.target.value) }}
                                                        autoComplete='off'
                                                        disabled={(!editKomponen || penerimaManfaat === 'On Site')}
                                                    />
                                                </Grid>
                                                :
                                                // geometryTipe === 'Point' &&
                                                <>
                                                    <Grid item lg={3} md={6} xs={12}>
                                                        <ArgonBox mb={1} ml={0.5}>
                                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                                Koordinat Latitude
                                                            </ArgonTypography>
                                                        </ArgonBox>
                                                        <ArgonInput
                                                            required={kec.id_kec !== '999'}
                                                            placeholder="Contoh: -5.559958566883871"
                                                            // multiline
                                                            // rows={7}
                                                            size="medium"
                                                            value={latitude}
                                                            onChange={(e) => { setLatitude(e.target.value) }}
                                                            autoComplete='off'
                                                            disabled={(!editKomponen || penerimaManfaat === 'On Site')}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={3} md={6} xs={12}>
                                                        <ArgonBox mb={1} ml={0.5}>
                                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                                Koordinat Logitude
                                                            </ArgonTypography>
                                                        </ArgonBox>
                                                        <ArgonInput
                                                            required={kec.id_kec !== '999'}
                                                            placeholder="Contoh: 122.83041671853309"
                                                            // multiline
                                                            // rows={7}
                                                            size="medium"
                                                            value={longitude}
                                                            onChange={(e) => { setLongitude(e.target.value) }}
                                                            autoComplete='off'
                                                            disabled={(!editKomponen || penerimaManfaat === 'On Site')}
                                                        />
                                                    </Grid>
                                                </>
                                        }
                                    </>
                                )
                            }
                        </Grid>
                        <Grid container spacing={2}>

                        </Grid>
                    </ArgonBox>
                }
            </CardContent>
            {
                editKomponen && (
                    <CardActions>
                        <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                            <Grid item>
                                <ArgonButton
                                    color='warning'
                                    variant='outlined'
                                    size="small"
                                    startIcon={<Close />}
                                    onClick={() => {
                                        setEditKomponen(false)
                                    }}
                                >
                                    Batal
                                </ArgonButton>
                            </Grid>
                            <Grid item>
                                <LoadingButton
                                    color='info'
                                    variant='contained'
                                    size="small"
                                    startIcon={<Save />}
                                    type='submit'
                                    loading={saving}
                                >
                                    Simpan
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </CardActions>
                )
            }
        </Card >
    )
}

export default UpdateKomponen